import { render, staticRenderFns } from "./default.vue?vue&type=template&id=13d6f378"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=13d6f378&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoreNav: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/StoreNav.vue').default,Feet: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Feet.vue').default,GeneralAlertModal: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/GeneralAlertModal.vue').default})
